import { StoreTemplate } from "@/templates/TemplateLoader";
import { FormattedDataType } from "@/templates/types";
import React from "react";
import { TResponsiveAspectRatio } from "@/shared/utils/aspect-ratio";
import useBreakPoints from "@/shared/utils/useBreakPoints";

interface RenderBannerCardProps {
  banner: FormattedDataType["banners"][0];
  section: Partial<FormattedDataType>;
  isSliderSection?: boolean;
  aspectRatio: TResponsiveAspectRatio;
}

const RenderBannerCard: React.FC<RenderBannerCardProps> = ({
  banner,
  section,
  isSliderSection,
  aspectRatio,
}) => {
  const { isTablet } = useBreakPoints();
  const Template = StoreTemplate.get();
  return (
    <Template.SectionCardWrapper
      isSlider={isSliderSection}
      data-test="banner-card"
      background={section?.background}
      aspectRatio={isTablet ? aspectRatio.mobile : aspectRatio.desktop}
    >
      <Template.BannerCard banner={banner} />
    </Template.SectionCardWrapper>
  );
};

export default RenderBannerCard;
